<template>
  <div>
    <div class="ui form" id="main">
      <h3 class="ui dividing header">Основная информация</h3>
      <div class="inline fields">
        <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] !== '05'">
          <div class="ui right pointing large label">
            Направление подготовки
          </div>
          <input type="text" placeholder="Специальность" v-model="main_info.speciality" disabled="true">
        </div>
        <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] === '05'">
          <div class="ui right pointing large label">
            Специальность
          </div>
          <input type="text" placeholder="Специальность" v-model="main_info.speciality" disabled="true">
        </div>
        <div class="four wide field">
          <div class="ui right pointing large label">
            Квалификация выпускника
          </div>
          <input type="text" placeholder="Квалификация" v-model="main_info.quality" disabled="true">
        </div>
      </div>
      <div class="inline fields">
        <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] !== '05'">
          <div class="ui right pointing large label">
            Профиль
          </div>
          <input type="text" placeholder="Профиль" v-model="main_info.profile" disabled="true">
        </div>
        <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] === '05'">
          <div class="ui right pointing large label">
            Специализация
          </div>
          <input type="text" placeholder="Профиль" v-model="main_info.profile" disabled="true">
        </div>
        <div class="two wide field">
          <div class="ui right pointing large label">
            Год набора
          </div>
          <input type="text" placeholder="Год набора" v-model="main_info.year" disabled="true">
        </div>
        <div class="three wide field">
          <div class="ui right pointing large label">
            Форма обучения
          </div>
          <input type="text" placeholder="Форма обучения" v-model="main_info.edu_form" disabled="true">
        </div>
      </div>
      <div class="ui equal width form">
        <div class="inline fields">
          <div class="four wide field">
            <div class="ui right pointing large label">
              И.О.Фамилия
            </div>
            <input type="text" placeholder="И.О.Фамилия" v-model="initial" disabled="true">
          </div>
          <div class="four wide field">
            <div class="ui right pointing large label">
              Должность
            </div>
            <input type="text" placeholder="Должность" v-model="main_info.creator.position" disabled="true">
          </div>
          <div class="four wide field">
            <div class="ui right pointing large label">
              Ученая степень
            </div>
            <input type="text" placeholder="Ученая степень" v-model="main_info.creator.title" disabled="true">
          </div>
        </div>
      </div>
      <div class="two fields">
        <div class="six wide field">
          <label>Выпускающая кафедра</label>
          <div class="ui input">
            <input type="text" placeholder="Выпускающая кафедра" v-model="main_info.grad_dep" disabled="true">
          </div>
        </div>
        <div class="six wide field">
          <label>Заведующий выпускающей кафедры</label>
          <div class="ui input">
            <input type="text" placeholder="Заведующий выпускающей кафедры" v-model="provisor" disabled="true">
          </div>
        </div>
      </div>
      <div class="three fields">
        <div class="five wide field">
          <label>Факультет</label>
          <div class="ui input">
            <input type="text" placeholder="Факультет" v-model="main_info.facility" disabled="true">
          </div>
        </div>
        <div class="five wide field">
          <label>Обеспечивающая кафедра</label>
          <div class="ui input">
            <input type="text" placeholder="Обеспечивающая кафедра" v-model="main_info.department" disabled="true">
          </div>
        </div>
        <div class="five wide field">
          <label>
            Заведующий кафедрой
          </label>
          <div class="ui input">
            <input type="text" placeholder="Заведующий кафедрой" v-model="main_info.dep_manager" disabled="true">
          </div>
        </div>
      </div>
      <div class="two fields">
        <div class="four wide field">
          <label>Дата заседания кафедры</label>
          <div class="ui input">
            <input type="text" placeholder="Дата заседания кафедры" v-model="main_info.approval_date" disabled="true">
          </div>
        </div>
        <div class="two wide field">
          <label>Протокол №</label>
          <div class="ui input">
            <input type="text" placeholder="Протокол №" v-model="main_info.protocol_num" disabled="true">
          </div>
        </div>
      </div>
      <div><textarea rows="2" v-model="main_info.basis" disabled="true"></textarea></div>
      <div class="two fields">
        <div class="four wide field">
          <label>Дата утверждения приказа</label>
          <div class="ui input">
            <input type="text" placeholder="Дата утверждения приказа" v-model="main_info.basis_date" disabled="true">
          </div>
        </div>
        <div class="two wide field">
          <label>№ Приказа</label>
          <div class="ui input">
            <input type="text" placeholder="№ Приказа" v-model="main_info.basis_num" disabled="true">
          </div>
        </div>
      </div>
      <div v-if="main_info.doc_type === 'ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ'">
        <h3 class="ui dividing header">1 Общие положения</h3>
        <textarea v-model="actives_type.actives" disabled="true" rows="30"></textarea>
        <h3 class="ui dividing header">2 Нормативные документы </h3>
        <textarea v-model="actives_type.tasks" disabled="true" rows="10"></textarea>
        <h3 class="ui dividing header">3 Объем выполнения научных исследований</h3>
        <div>
          Научные исследования аспиранта – это самостоятельная работа, ориентированная на  получение индивидуального научного результата
        </div>
        <div>
          Объем научных исследований аспиранта определяется учебным планом на весь периода  обучения:
        </div>
        <div class="inline fields">
          <div class="nine wide field">
            Общая трудоемкость выполнения научных исследований составляет
          </div>
          <div  class="one wide">
            <input type="text" placeholder="Зачетных едениц" v-model="main_info.zet" disabled="true">
          </div>
          <div class="three wide field">
            зачетных единиц
          </div>
          <div class="one wide">
            <input type="text" placeholder="Академ часов" v-model="main_info.hour" disabled="true">
          </div>
          <div class="two wide field">
            (ак.ч.)
          </div>
        </div>
        <h3 class="ui dividing header">4 Этапы выполнения научных исследований</h3>
        <table class="ui basic celled table">
          <thead>
          <tr class="active">
            <th width="10%"><div class="headTable">Этапы</div></th>
            <th width="50%"><div class="headTable">Перечень работ по этапам </div></th>
            <th width="10%"><div class="headTable">Курс</div></th>
            <th width="30%"><div class="headTable">Форма</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for = "dis in discipline">
            <td colspan="4">
              <table class="ui basic celled table">
                <thead>
                <tr class="active">
                  <th colspan="4" width="5%">{{ dis.name }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for = "work in dis.work">
                  <td width="10%">{{ work.stage }}</td>
                  <td width="50%" v-html="work.content"></td>
                  <td width="10%">{{ work.course }}</td>
                  <td width="30%">{{ work.control }}</td>
                </tr>
                </tbody>
              </table>
            </td>
          </tr>
          </tbody>
        </table>
        <h3 class="ui dividing header">5 Текущий контроль и промежуточная аттестация по этапам выполнения научного исследования</h3>
        <span v-html="text_info.structure"></span>
        <h3>6 Учебно-методическое и информационное обеспечение выполнения плана научной деятельности</h3>
        <div>
          <h4>1 Рекомендуемая литература</h4>
          <span v-html="text_info.literature"></span>
          <h5>2 Программное обеспечение и Интернет-ресурсы</h5>
          <h5>Программное обеспечение</h5>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "soft in software">
              <td>
                {{soft.info.name}}
              </td>
              <td>
                {{ soft.info.license }}
              </td>
            </tr>
            <tr v-for = "res in resources">
              <td>{{res.name}}</td>
              <td>{{res.desc}}</td>
            </tr>
            </tbody>
          </table>
          <h4>3 Профессиональные базы данных и информационные справочные системы</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "db in data_bases">
              <td>{{db.name}}</td>
              <td>{{db.desc}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <h3>7 Материально-техническое обеспечение выполнения плана научной деятельности</h3>
        <span v-html="text_info.subject"></span>
      </div>
      <div v-else-if="main_info.doc_type === 'ПРОГРАММА ИТОГОВОЙ АТЕСТАЦИИ'">
        <h3 class="ui dividing header">1 Общие положения</h3>
        <textarea v-model="actives_type.actives"></textarea>
        <h3 class="ui dividing header">2 Нормативные документы </h3>
        <textarea v-model="actives_type.tasks" disabled="true" rows="15"></textarea>
        <h3 class="ui dividing header">3 Требования к подготовленной диссертации и её представлению</h3>
        <textarea v-model="text_info.structure" disabled="true" rows="100"></textarea>
      </div>
      <div v-else>
        <h3 class="ui dividing header">1 ОБЩИЕ ПОЛОЖЕНИЯ</h3>
        <div>
          <h4>1.2 Виды деятельности выпускников и соответствующие им типы задач профессиональной деятельности:</h4>
          <h5>1.2.1 Виды деятельности выпускников</h5>
          <span v-html="actives_type.actives"></span>
          <h5>1.2.2 Типы задач профессиональной деятельности</h5>
          <span v-html="actives_type.tasks"></span>
          <h5>1.2.3. Требования к профессиональной подготовленности выпускника, необходимые для выполнения им задач профессиональной деятельности</h5>
          <div>
            <div class="ui form"><textarea rows="2" type="text" placeholder="Преамбула к компетенциям" v-model="text_info.preamble_comp" disabled="true"></textarea></div>
            <h4>а) Универсальные компетенции выпускников и индикаторы их достижения</h4>
            <table class="ui basic celled table">
              <thead>
              <tr class="active">
                <th width="20%"><div class="headTable">Категория (группа) универсальных компетенций</div></th>
                <th width="40%"><div class="headTable">Код и наименование универсальной компетенции</div></th>
                <th width="40%"><div class="headTable">Код и наименование индикатора достижения универсальной компетенции</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "comp in rpg_competitions.UK">
                <td>{{comp.info.cat}}</td>
                <td>
                  {{ comp.info.code }} {{ comp.info.desc }}
                </td>
                <td v-html="comp.text"></td>
              </tr>
              </tbody>
            </table>
            <h4>б) Общепрофессиональные компетенции выпускников и индикаторы их достижения</h4>
            <table class="ui basic celled table" v-if="OPK.length">
              <thead>
              <tr class="active">
                <th width="20%"><div class="headTable">Категория (группа) общепрофессиональных компетенций</div></th>
                <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                <th width="40%"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "comp in rpg_competitions.OPK_cat">
                <td>{{comp.info.cat}}</td>
                <td>
                  {{ comp.info.code }} {{ comp.info.desc }}
                </td>
                <td v-html="comp.text"></td>
              </tr>
              </tbody>
            </table>
            <table class="ui basic celled table" v-if="!OPK.length">
              <thead>
              <tr class="active">
                <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                <th width="60%"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "comp in rpg_competitions.OPK">
                <td>{{comp.name}}</td>
                <td v-html="comp.text"></td>
              </tr>
              </tbody>
            </table>
            <h4>3.3 Профессиональные компетенции и индикаторы их достижения</h4>
            <table class="ui basic celled table">
              <thead>
              <tr class="active">
                <th width="40%"><div class="headTable">Код и наименование профессиональной компетенции</div></th>
                <th width="60%"><div class="headTable">Код и наименование индикатора достижения профессиональной компетенции</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "comp in rpg_competitions.PK">
                <td>{{comp.name}}</td>
                <td v-html="comp.text"></td>
              </tr>
              </tbody>
            </table>
            <h4>г) Дополнительные профессиональные компетенции выпускников и индикаторы их достижения</h4>
            <table class="ui basic celled table">
              <thead>
              <tr class="active">
                <th width="40%"><div class="headTable">Код и наименование дополнительной профессиональной компетенции</div></th>
                <th width="60%"><div class="headTable">Код и наименование индикатора достижения дополнительной профессиональной компетенции</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "comp in rpg_competitions.DPK">
                <td>{{comp.name}}</td>
                <td v-html="comp.text"></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <h3 class="ui dividing header">2 ТРЕБОВАНИЯ К ВЫПУСКНОЙ КВАЛИФИКАЦИОННОЙ РАБОТЕ</h3>
        <h4>2.2. Структура выпускной квалификационной работы и требования к ее содержанию</h4>
        <span v-html="text_info.structure"></span>
        <h4>2.3 Примерная тематика и порядок утверждения тем выпускных квалификационных работ</h4>
        <span v-html="text_info.subject"></span>
        <h4>2.4 Учебно-методическое и информационное обеспечение</h4>
        <div>
          <h5>2.4.1 Рекомендуемая литература</h5>
          <span v-html="text_info.literature"></span>
          <h5>2.4.2 Программное обеспечение и Интернет-ресурсы</h5>
          <h5>Программное обеспечение</h5>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "soft in software">
              <td>
                {{soft.info.name}}
              </td>
              <td>
                {{ soft.info.license }}
              </td>
            </tr>
            <tr v-for = "res in resources">
              <td>{{res.name}}</td>
              <td>{{res.desc}}</td>
            </tr>
            </tbody>
          </table>
          <h4>2.4.3 Профессиональные базы данных и информационные справочные системы</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "db in data_bases">
              <td>{{db.name}}</td>
              <td>{{db.desc}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <h4>2.5 Порядок выполнения и представления в ГЭК выпускной квалификационной работы</h4>
        <span v-html="text_info.order_execution"></span>
        <h4>2.6 Порядок защиты выпускной квалификационной работы</h4>
        <span v-html="text_info.order_def"></span>
        <h4>2.7 Критерии выставления оценок (соответствия уровня подготовки выпускника требованиям ФГОС ВО) на основе выполнения и защиты им квалификационной работы </h4>
        <span v-html="text_info.criteria"></span>
        <div v-if="main_info.speciality_code === '40.03.01' || main_info.speciality_code === '41.03.01' || main_info.speciality_code === '41.04.01'">
          <h3 class="ui dividing header">3 ТРЕБОВАНИЯ К ВЫПУСКНИКУ, ПРОВЕРЯЕМЫЕ В ХОДЕ ГОСУДРАСТВЕННОГО ЭКЗАМЕНА</h3>
          <h4>3.1 Перечень основных учебных модулей – дисциплин образовательной программы или их разделов и вопросов, выносимых для проверки на государственном экзамене</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th>Дисциплина (раздел дисциплины)</th>
              <th>Перечень вопросов</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "work in discipline">
              <td width="30%">{{ work.name }}</td>
              <td width="68%" v-html="work.content"></td>
            </tr>
            </tbody>
          </table>
          <h4>3.2 Список рекомендуемой литературы</h4>
          <span v-html="text_info.literature_gos"></span>
          <h4>3.3 Критерии выставления оценок на государственном экзамене</h4>
          <span v-html="text_info.criteria_gos"></span>
          <h4>3.4 Порядок проведения экзамена</h4>
          <span v-html="text_info.order_examination"></span>
        </div>
      </div>
      <div v-if="department_manager">
        <button class="ui button negative" v-on:click="denyRPGDepartment(rpg_id, department_agreed_times, department_comment)">
          Отклонить
        </button>
        <button class="ui right floated button positive" v-on:click="agreedRPGDepartment(rpg_id)">
          Согласовать
        </button>
      </div>
      <div class="ui modal" id="deny_umu_modal">
        <div class="ui header">Отклонить?</div>
        <div class="content">
          <div class="ui form">
            <div class="field">
              <label>Оставить отзыв (опционально)</label>
              <textarea v-model="deny_text"></textarea>
            </div>
          </div>
        </div>
        <div class="actions">
          <div class="ui gray deny button">
            Закрыть
          </div>
          <div class="ui positive inverted right labeled icon button">
            Подтвердить
            <i class="checkmark icon"></i>
          </div>
        </div>
      </div>
      <div class="ui modal" id="error_umu_modal">
        <div class="ui header">Произошла ошибка</div>
        <div class="content">
          <div class="ui form">
            <div class="field">
              <label v-model="error_message_text"></label>
            </div>
          </div>
        </div>
        <div class="actions">
          <div class="ui gray deny button">
            Закрыть
          </div>
          <div class="ui positive inverted right labeled icon button">
            Подтвердить
            <i class="checkmark icon"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import competitionsMixin from "../mixins/competitionsMixin";
import dataMixin from "../mixins/dataMixin";
import dataRpgMixin from "../mixins/dataRpgMixin";
import computedMixin from "../mixins/computedMixin";

export default {
  name: "show_rpg",
  mixins: [competitionsMixin, dataMixin, dataRpgMixin, computedMixin],
  data: () => ({
    deny_text: "",
    umu_comment: "",
    department_agreed_times: 1,
    department_manager: false,
    department_comment: "",
    error_message_text: "",
  }),
  computed: {
  },

  methods: {
    getRPG(id) {
      axios({
        method: 'get',
        url: `/programms/get_rpg/${id}`,
      }).then((response) => {
        this.text_info.structure = response.data.rpg.structure_old;
        this.text_info.subject = response.data.rpg.subject_old;
        this.text_info.order_execution = response.data.rpg.order_execution_old;
        this.text_info.order_def = response.data.rpg.order_def_old;
        this.text_info.order_examination = response.data.rpg.order_examination_old;
        this.text_info.criteria = response.data.rpg.criteria_old;
        this.text_info.criteria_gos = response.data.rpg.criteria_gos_old;
        this.text_info.literature_gos = response.data.rpg.literature_gos_old;
        this.text_info.literature = response.data.rpg.literature_old;
        this.text_info.preamble_comp = response.data.rpg.preamble_comp;
        this.software = response.data.rpg.software;
        this.resources = response.data.rpg.resources;
        this.data_bases = response.data.rpg.data_bases;
        this.discipline = response.data.rpg.discipline;
        this.actives_type = response.data.rpg.active_type;
        this.rpg_competitions = response.data.rpg.competition;
        this.main_info = response.data.rpg.main_info;
        this.curriculum_id = response.data.rpg.curriculum_id;
        this.discipline_id = response.data.rpg.discipline_id;
        this.department_agreed = response.data.rpg.department_agreed;
        this.department_agreed_times = response.data.rpg.department_agreed_times;
        this.department_comment = response.data.rpg.department_comment;
        this.getGraduatedDep(this.curriculum_id)
      }).catch((error) => {
        return error;
      });
    },
    getGraduatedDep(curriculum_id) {
      axios({
        method: 'get',
        url: `/programms/get_grad_dep/${curriculum_id}`,
      }).then((response) => {
        this.select_options.departments = response.data.departments;
      }).catch((error) => {
        return error;
      });
    },
    denyRPGDepartment(id, times, text){
      this.deny_text = text;
      $('#deny_umu_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpg/' + id,
            data: {
              data: {
                department_agreed: false,
                department_comment: this.deny_text,
                department_agreed_times: times + 1,
                considered: false,
              }
            }
          }).then((response) => {
            if(response.status == 200 || response.status == 204){
              location.assign('/programms/rpd')
            } else {
              $('#error_umu_modal').modal({
                closable: false,
                autofocus: false,
                onDeny: () => {
                },
                onApprove: () => {
                }
              }).modal('show');
            }
          }).catch((error) => {
            this.error_message_text = error.response.data,
                $('#error_umu_modal').modal({
                  closable: false,
                  autofocus: false,
                  onDeny: () => {
                  },
                  onApprove: () => {
                  }
                }).modal('show');
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPGDepartment(id){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpg/' + id,
        data: {
          data: {
            department_agreed: true,
          }
        }
      }).then((response) => {
        if(response.status == 200 || response.status == 204){
          location.assign('/programms/rpd')
        } else {
          $('#error_umu_modal').modal({
            closable: false,
            autofocus: false,
            onDeny: () => {
            },
            onApprove: () => {
            }
          }).modal('show');
        }
      }).catch((error) => {
        this.error_message_text = error.response.data,
            $('#error_umu_modal').modal({
              closable: false,
              autofocus: false,
              onDeny: () => {
              },
              onApprove: () => {
              }
            }).modal('show');
        return error;
      });
    },
    departmentManager(){
      axios({
        method: 'get',
        url: `/programms/department_manager`,
      }).then((response) => {
        this.department_manager = response.data.umu;
      }).catch((error) => {
        return error;
      });
    },
  },
  mounted() {
    this.rpg_id = window.location.pathname.split('/')[3]
    this.getRPG(this.rpg_id)
    this.departmentManager()
  }
}
</script>

<style scoped>

</style>